<template>
  <header class="page-header section is-header">
    <div class="container">
      <div>
        <h1 v-if="title" class="title is-h1 text-balance" itemprop="name">
          {{ title }}
        </h1>
        <div
          v-if="subtitle"
          class="subtitle is-h3 text-balance"
          itemprop="description"
          v-html="subtitle"
        />
      </div>
      <slot />
    </div>
  </header>
</template>

<script lang="ts" setup>
defineProps<{
  title?: string
  subtitle?: string
}>()
</script>
